import { render, staticRenderFns } from "./FundHoldingSummary.vue?vue&type=template&id=44739ed3&scoped=true"
import script from "./FundHoldingSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./FundHoldingSummary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FundHoldingSummary.vue?vue&type=style&index=0&id=44739ed3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44739ed3",
  null
  
)

export default component.exports